import { ROUTE_ID_MAPPING_WEB, ROUTE_ID_MAPPING_TERMINAL } from '~/config/ids/idsRoutes';
import { WINTER, SUMMER } from '~/config/types/typesSeasons';

export default {

    /**
     * Validates the resort routes if the route parameters are correct
     */
    validate({ params, query, store, router, route }) {
        const routes = route.name.includes('terminal') ? ROUTE_ID_MAPPING_TERMINAL : ROUTE_ID_MAPPING_WEB;
        return [WINTER, SUMMER].includes(params.season)
               && Object.keys(routes[params.season]).includes(params.resort);
    },
};
